import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_whistleblower_system_in_place'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_whistleblower_system_in_place',
  name: 'Does the facility have a whistleblower system in place?',
  description:
    'The intent of this question is to understand if the facility has a whistleblower system in place for workers to report wrongdoings/ illegal activities that affect other workers and/or the public.\r\r\n \r\r\nFor this question, whistleblower means a person who discloses/ reports information through the whistleblower system about wrongdoing that affects the public or the workers at large (e.g., fraud, corruption, abuse, risks, negligence) that otherwise would not be known.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-whi-1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13200,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
